export default "__VITE_ASSET__Bkko2R1C__";